function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V6.5C1.5 7.05228 1.94772 7.5 2.5 7.5H6.5C7.05228 7.5 7.5 7.05228 7.5 6.5V2.5C7.5 1.94772 7.05228 1.5 6.5 1.5Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 4L5 5.5L7 3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 1.5H9.5C8.94772 1.5 8.5 1.94772 8.5 2.5V6.5C8.5 7.05228 8.94772 7.5 9.5 7.5H13.5C14.0523 7.5 14.5 7.05228 14.5 6.5V2.5C14.5 1.94772 14.0523 1.5 13.5 1.5Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 4L12 5.5L14 3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5H2.5C1.94772 8.5 1.5 8.94772 1.5 9.5V13.5C1.5 14.0523 1.94772 14.5 2.5 14.5H6.5C7.05228 14.5 7.5 14.0523 7.5 13.5V9.5C7.5 8.94772 7.05228 8.5 6.5 8.5Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 11L5 12.5L7 10",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 8.5H9.5C8.94772 8.5 8.5 8.94772 8.5 9.5V13.5C8.5 14.0523 8.94772 14.5 9.5 14.5H13.5C14.0523 14.5 14.5 14.0523 14.5 13.5V9.5C14.5 8.94772 14.0523 8.5 13.5 8.5Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 11L12 12.5L14 10",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSelectAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.f8761c74.svg";
export { ForwardRef as ReactComponent };